export const COMPETITOR_DIGEST_REPORT = {
  headline: 'Metricly cut prices · Quantly shipped agents',
  status: 'done',
  durationSec: 84,
  body: `**4 competitors checked — 3 notable changes in the last 24 hours.**

- **Metricly** — Cut its Team plan from $35 to $29 per user and added a 14-day free trial.
  *Why it matters:* expect it in procurement conversations at mid-market accounts.
- **Quantly** — Launched “Quantly Agents”, which build a notebook from a plain-English question. Enterprise plan only for now.
- **Lensboard** — Hired a new CRO and announced an India data region for next quarter.
- **ChartHouse** — No changes.

| Competitor | Pricing | Product | People |
|---|---|---|---|
| Metricly | Changed | — | — |
| Quantly | — | Changed | — |
| Lensboard | — | Changed | Changed |
| ChartHouse | — | — | — |

Posted to #market-intel.`,
}
